import { useEffect } from "react";
import { useNavigate } from "react-router";
import { completeOnboarding } from "@/lib/stores/developer";

export default function Onboarding() {
  const navigate = useNavigate();

  useEffect(() => {
    // For admin app, immediately complete onboarding and navigate to login
    completeOnboarding();
    navigate("/login", { replace: true });
  }, [navigate]);

  // Show a brief loading state while redirecting
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="mb-2 text-2xl font-bold text-primary">Vizi Admin</h1>
        <p className="text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}
